import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  Fade,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
} from '@mui/material';
import { NavLink, useNavigate } from 'react-router-dom';
import NavLinkItem from './NavLinkItem';
import { buttonBgColor, primaryColor, tabBgColor, textColor } from '../../utils/themeColor';
import { smallMobile } from '../../utils/resolution';
import { useEffect, useState } from 'react';
import { clearStorage } from '../../utils';

const NavBar = () => {
  const navigate = useNavigate();

  const [smMobile, setSmMobile] = useState(window.innerWidth <= smallMobile);
  const [loggingOut, setLoggingOut] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const username = localStorage.getItem('username');

  useEffect(() => {
    const handleResize = () => {
      setSmMobile(window.innerWidth <= smallMobile);
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const navItems = [
    { label: 'Chat', to: '/' },
    { label: 'Files', to: '/files' },
  ];

  const handleLogout = async () => {
    setLoggingOut(true);
    clearStorage();

    setTimeout(() => {
      setLoggingOut(false);
      navigate('/login');
    }, 1500);
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClick = () => {
    handleMenuClose();
    handleLogout();
  };

  return (
    <>
      <Box
        sx={{
          pl: 4,
          py: 4,
          width: { xs: '100%', sm: '500px' },
          mx: 'auto',
          backgroundColor: '#fff',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: { xs: 'space-between', sm: 'space-between' },
            pb: 1.5,
          }}
        >
          <Box>
            <Typography sx={{ fontWeight: 'bold' }}>Walmart Sentiment Ai</Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              pr: { xs: 4, sm: 0 },
            }}
          >
            <Typography sx={{ color: textColor, fontSize: '14px' }}>{username}</Typography>
            <IconButton onClick={handleMenuOpen}>
              <Avatar
                sx={{
                  width: { xs: 30, sm: 35 },
                  height: { xs: 30, sm: 35 },
                  bgcolor: buttonBgColor,
                  fontSize: '14px',
                }}
              >
                {username?.charAt(0).toUpperCase()}
              </Avatar>
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              PaperProps={{
                sx: {
                  mt: 1,
                  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
                  borderRadius: '8px',
                },
              }}
            >
              <MenuItem onClick={handleLogoutClick}>Logout</MenuItem>
            </Menu>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: { xs: 'end', sm: 'center' },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              backgroundColor: tabBgColor,
              width: { xs: '100%', sm: '100%' },
              borderTopLeftRadius: '30px',
              borderBottomLeftRadius: '30px',
              borderRadius: { xs: 'none', sm: '30px' },
              overflow: 'hidden',
            }}
          >
            {navItems.map((item, index) => (
              <NavLinkItem
                key={item.to}
                to={item.to}
                label={item.label}
                isLast={index === navItems.length - 1}
              />
            ))}
          </Box>
        </Box>
      </Box>

      <Dialog
        open={loggingOut}
        aria-labelledby="logout-dialog-title"
        TransitionComponent={Fade}
        transitionDuration={400}
        PaperProps={{
          sx: {
            borderRadius: 4,
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
            minWidth: { xs: '80%', sm: '350px' },
            py: 2,
          },
        }}
      >
        <DialogContent sx={{ textAlign: 'center', py: 4 }}>
          <CircularProgress size={60} thickness={4} color="primary" sx={{ mb: 3 }} />
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: primaryColor }}>
            Logging Out
          </Typography>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default NavBar;
